import { render } from "./AccessToken.vue?vue&type=template&id=1e378260&scoped=true"
import script from "./AccessToken.vue?vue&type=script&lang=js"
export * from "./AccessToken.vue?vue&type=script&lang=js"

import "./AccessToken.vue?vue&type=style&index=0&id=1e378260&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e378260"]])

export default __exports__